import axios from "axios";
import axiosUrl from "./axios.service";
import store from "../store/index";
import requestState from "../helpers/requestState";

const API_URL = axiosUrl.getAxiosUrl();

class AuthService {
  async login(user) {
    return await axios.post(API_URL + "/users/authenticate", {
      email: user.email,
      password: user.password,
    })
		.then(async () => {
      requestState.isLogoutInProgress = false;
      requestState.isRefreshing = false;
      requestState.isRateLimitActive = false;
      requestState.refreshPromise = null;
			await this.getAuthUserData();
		})
		.catch((error) => {
			store.commit('auth/setAuthUser', null);
			store.commit('auth/updateModalError', error.response.data);
			store.commit('auth/enableModalError');
		});
  }

  async logout(serverSideLogout) {
    store.commit("auth/setAuthUser", null);

    if (serverSideLogout)
      return await axios.post(API_URL + "/auth/logout");
  }

  async getEnvironment() {
    return await axios.get(API_URL + "/users/getEnvironment").then((response) => {
      store.commit("auth/setEnvironment", response.data);
    });
  }

  async getPortalInfo() {
    return await axios
      .get(API_URL + "/users/getPortalInfo")
      .then((response) => {
        store.commit(
          "auth/setCustomerPortalName",
          response.data.customerPortalName
        );
      });
  }

  async register(user) {
    return await axios.post(API_URL + "/users/register", {
      firstName: user.firstName,
      lastName: user.lastName,
      portalOrganisation: user.organisation,
      email: user.email,
    });
  }
	
  
  async getAuthUserData() {
    return await axios
    .get(API_URL + '/auth/getAuthUserData')
    .then((response) => {
      store.commit('auth/setAuthUser', response.data);
    })
    .catch((error) => {
			throw error;
    });
  }

  async refreshToken() {
    return await axios.post(API_URL + '/auth/refresh')
			.catch((error) => {
				throw error;
			});
  }
}

export default new AuthService();
